import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CartProvider } from "./lib/cart";
import { AuthProvider } from "./lib/auth";
import { WishlistProvider } from "./lib/wishlist";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import ProductPage from "./pages/ProductPage";
import SymptomCheckerPage from "./pages/SymptomCheckerPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AboutPage from "./pages/AboutPage";
import { BlogListPage, BlogPostPage } from "./pages/BlogPage";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import { PrivacyPage, TermsPage } from "./pages/PoliciesPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AccountPage from "./pages/AccountPage";
import OrderDetailPage from "./pages/OrderDetailPage";
import ScrollToTop from "./components/ScrollToTop";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
import AdminProductsPage from "./pages/admin/AdminProductsPage";
import AdminInventoryPage from "./pages/admin/AdminInventoryPage";
import AdminCustomersPage from "./pages/admin/AdminCustomersPage";
import AdminContentPage from "./pages/admin/AdminContentPage";
import AdminRolesPage from "./pages/admin/AdminRolesPage";
import AdminStaffPage from "./pages/admin/AdminStaffPage";
import WishlistPage from "./pages/WishlistPage";
import InvoicePage from "./pages/InvoicePage";
import { ChatbotProvider } from "./lib/chatbot";
import ChangePasswordPage from "./pages/ChangePasswordPage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
        <WishlistProvider>
        <CartProvider>
        <ChatbotProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/symptom-checker" element={<SymptomCheckerPage />} />
                <Route path="/find-my-fit" element={<SymptomCheckerPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/blog" element={<BlogListPage />} />
                <Route path="/blog/:slug" element={<BlogPostPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/change-password" element={<ChangePasswordPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/account/orders/:orderId" element={<OrderDetailPage />} />
                <Route path="/wishlist" element={<WishlistPage />} />

              </Route>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboardPage />} />
                <Route path="orders" element={<AdminOrdersPage />} />
                <Route path="products" element={<AdminProductsPage />} />
                <Route path="inventory" element={<AdminInventoryPage />} />
                <Route path="customers" element={<AdminCustomersPage />} />
                <Route path="content" element={<AdminContentPage />} />
                <Route path="roles" element={<AdminRolesPage />} />
                <Route path="staff" element={<AdminStaffPage />} />
              </Route>
              {/* Standalone routes (no Layout / AdminLayout) */}
              <Route path="/invoice/:orderId" element={<InvoicePage />} />
            </Routes>
          </BrowserRouter>
        </ChatbotProvider>
        </CartProvider>
        </WishlistProvider>
      </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
